/**
 * Caready Customer Web - Color Palette
 *
 * File ini berisi semua warna yang digunakan di aplikasi.
 * Gunakan konstanta ini untuk inline styles agar mudah dimaintain.
 *
 * Untuk Tailwind classes, gunakan prefix tw- (contoh: tw-bg-primary, tw-text-success)
 */

const colors = {
  // Brand Colors
  primary: "#CF1701",
  primaryDark: "#9D1101",
  secondary: "#092540",

  // Text Colors
  textPrimary: "#092540",
  textSecondary: "#687083",
  textDark: "#1E1E1F",
  textMuted: "#3C3C3D",
  textWhite: "#FFFFFF",

  // Status Colors
  success: "#2AB95E",
  successDark: "#1D8242",
  successLight: "#EAF8EF",

  danger: "#FF4D4D",
  dangerDark: "#B33636",
  dangerLight: "#FFEDED",
  dangerBg: "#FFEBEB",

  warning: "#A84D20",
  warningLight: "#FEF8E7",

  info: "#295ECC",
  infoLight: "#F0F8FE",

  // UI Colors
  orange: "#EA9437",
  orangeLight: "#FF6A39",
  orangeBorder: "#FFB836",

  blue: "#007BFF",
  purple: "#800080",

  // Background Colors
  bgWhite: "#FFFFFF",
  bgGrey: "#EBEBEB",
  bgGreyLight: "#E6E8EB",

  // Border Colors
  borderLight: "#DADCE0",

  // Specific Use Cases
  bidDisabledActive: "#2AB95E",
  bidDisabledInactive: "#FF0000",

  // NIPL Colors
  niplBg: "#FF6A39",
  niplYellow: "#FFFF4A",
  niplOrange: "#FFB836",

  // Socket Status Colors
  socketConnected: "#28a745",
  socketReconnecting: "#ffc107",
  socketDisconnected: "#fd7e14",
  socketError: "#dc3545",
  socketUnknown: "#6c757d",

  // Alert Background
  alertDangerBg: "#F9E6E6",
};

/**
 * Fungsi helper untuk mengakses warna dengan mudah
 * @param {string} colorName - Nama warna dari object colors
 * @returns {string} Hex color code
 */
export const getColor = (colorName) => {
  return colors[colorName] || "#000000";
};

/**
 * Export individual colors untuk kemudahan import
 */
export const {
  primary,
  primaryDark,
  secondary,
  textPrimary,
  textSecondary,
  textDark,
  textMuted,
  textWhite,
  success,
  successDark,
  successLight,
  danger,
  dangerDark,
  dangerLight,
  dangerBg,
  warning,
  warningLight,
  info,
  infoLight,
  orange,
  orangeLight,
  orangeBorder,
  blue,
  purple,
  bgWhite,
  bgGrey,
  bgGreyLight,
  borderLight,
  bidDisabledActive,
  bidDisabledInactive,
  niplBg,
  niplYellow,
  niplOrange,
  socketConnected,
  socketReconnecting,
  socketDisconnected,
  socketError,
  socketUnknown,
  alertDangerBg,
} = colors;

export default colors;
